export default __webpack_public_path__ + "static/media/Emblem_of_Israel.7835a207.svg";